import Manuals from './files';

export default Manuals;
